module.exports = __webpack_public_path__ + "static/netflix-tudum-7-1a7f227fec99dfcc3e9eb77cbb136c00.jpg";